<template>
  <div v-if="filteredArticles.length > 0" class="q-gutter-sm q-my-sm">
    <slot />

    <ArticleItem
      v-for="(article, key) in filteredArticles"
      :key="key"
      :article="article"
    />
  </div>
  <div v-else-if="showNoResults">
    <no-results
      without-icon
      title="No articles to display"
      align="left"
      padding="q-px-none q-py-sm"
    />
  </div>
</template>

<script>
import ArticleItem from 'components/layout/help/ArticleItem'

/**
 * Articles component will display a list of articles filtered to the specific defined tags
 *
 * SLOTS:
 * - default: default content to display if results exist
 */
export default {
  components: {
    ArticleItem
  },
  props: {
    // Types of articles to show in the list (YOUTUBE, ARTICLE, COLLECTION)
    types: {
      type: Array,
      default: () => {
        return ['YOUTUBE']
      }
    },
    // Help Tags to filter the list by
    tags: {
      type: Array,
      default: () => {
        return []
      }
    },
    // Apply a search term over the titles of articles
    searchTerm: {
      type: String,
      default: null
    },
    // Show no results text if no results exist
    showNoResults: {
      type: Boolean,
      default: false
    },
    // Filter maximum amount of results which can be displayed in the list
    limit: {
      type: Number,
      default: null
    }
  },
  computed: {
    articles () {
      return this.$store.getters['articles/getArticles']
    },
    filteredArticles () {
      const results = []

      for (const article of this.articles) {
        const hasTypes = this.types.includes(article.type)
        if (!hasTypes) {
          continue
        }

        const tags = article.tags.map(item => item.tag)
        const hasTags = (this.tags.length < 1 || tags.filter(t => this.tags.includes(t)).length > 0)
        if (!hasTags) {
          continue
        }

        const hasSearchTerm = (!this.searchTerm || (article.title || '').toLowerCase().includes(this.searchTerm.toLowerCase()))
        if (!hasSearchTerm) {
          continue
        }

        results.push(article)
        if (this.limit && results.length >= this.limit) {
          break
        }
      }

      return results
    }
  }
}
</script>
